var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIncidentB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.67,151.28c0-9.18,4.76-16.32,16-16.32h52.7c42.84,0,65.28,30.26,65.28,57.8,0,26.52-13.94,46.92-33.66,53v.68c29.24,3.06,52.36,27.88,52.36,59.84,0,38.08-28.22,70.72-79.22,70.72H203.65c-11.22,0-16-7.14-16-16.32Zm29.92,86h34c25.5,0,40.12-17,40.12-39.1,0-21.76-12.58-37.4-39.1-37.4h-35Zm0,113.9h42.16c29.24,0,50.66-18,50.66-44.88,0-24.82-18-44.54-49.3-44.54H217.59ZM256,480C132.49,480,32,379.51,32,256S132.49,32,256,32,480,132.49,480,256,379.51,480,256,480Zm0-416C150.13,64,64,150.13,64,256s86.13,192,192,192,192-86.13,192-192S361.87,64,256,64Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncidentB);
export default __webpack_public_path__ + "static/media/icon-incident-b.0bdca3d8.svg";
export { ForwardRef as ReactComponent };